export enum MarketStatus {
  Created = 0,
  Backing = 1,
  Trading = 2,
  Resolved = 3,
  Graduated = 4,
}

export type MarketStatusString = 'created' | 'backing' | 'trading' | 'resolved' | 'graduated';

export const MARKET_STATUS_STRINGS: ReadonlySet<string> = new Set<MarketStatusString>([
  'created',
  'backing',
  'trading',
  'resolved',
  'graduated',
]);

export function isMarketResolved(status: string): boolean {
  return status === 'resolved' || status === 'graduated';
}

export function isMarketTerminal(status: string): boolean {
  return status === 'graduated';
}

export function isMarketTradeable(status: string): boolean {
  return status === 'trading';
}

export const TRADEABLE_STATUS_CODES: readonly number[] = [MarketStatus.Trading] as const;

export function isValidMarketStatus(status: string): status is MarketStatusString {
  return MARKET_STATUS_STRINGS.has(status);
}
